import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as FieldComponents from "@Shared/components/sections/index";
import MaterialInput from "@Shared/components/inputs/material-input";
import Select2 from "@Shared/components/inputs/select2";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import { createHelpers } from "@joandvgv/vuex-map-fields";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import { InterestTypeE, MortgageInsurerE, PaymentFrequencyE, TermTypeE } from "@Broker/js/utils/enum";
import { map } from "lodash";
const {
  mapFields: mapMortgage
} = createHelpers({
  getterType: "getManualSubmissionMortgage",
  mutationType: "setManualSubmissionMortgage"
});
const {
  mapFields: mapDeal
} = createHelpers({
  getterType: "getManualSubmissionDeal",
  mutationType: "setManualSubmissionDeal"
});
const {
  mapFields: mapResponse
} = createHelpers({
  getterType: "getManualSubmissionResponse",
  mutationType: "setManualSubmissionResponse"
});
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ResponseDetailsBlock",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    MaterialInput,
    Select2,
    DatepickerInput
  }),
  mixins: [validationMixin],
  props: {
    submittedApplicationId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      amountsMask: {
        alias: "currency",
        rightAlign: false,
        prefix: "",
        showMaskOnHover: false,
        allowMinus: false,
        allowPlus: false,
        autoUnmask: true,
        repeat: 10
      },
      periodMask: {
        alias: "numeric",
        mask: "9[9][9]",
        placeholder: "0",
        showMaskOnHover: false,
        greedy: false,
        rightAlign: false
      },
      percentMask: {
        alias: "numeric",
        mask: "9[9][9].9[99]",
        placeholder: "0",
        greedy: false,
        rightAlign: false,
        showMaskOnHover: false
      },
      select2Options: {
        closeOnSelect: true,
        placeholder: this.$t("global.words.select"),
        dropdownCssClass: "response-details-select",
        dropdownParent: $("#manual-response-modal"),
        minimumResultsForSearch: -1
      }
    };
  },
  validations: {
    netLoanAmount: {
      required,
      minValue: minValue(0.1)
    },
    PAndIPaymentAmount: {
      required,
      minValue: minValue(0.1)
    },
    interestAdjustmentDate: {
      required
    },
    totalLoanAmount: {
      required,
      minValue: minValue(0.1)
    },
    netRate: {
      required,
      minValue: minValue(0.1)
    },
    interestTypeDd: {
      required
    },
    actualPaymentTerm: {
      required,
      minValue: minValue(1)
    },
    paymentTermDd: {
      required
    },
    paymentFrequencyDd: {
      required
    },
    estimatedClosingDate: {
      required
    },
    commitmentExpirationDate: {
      required
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapMortgage("ApplicationStore", ["netLoanAmount", "totalLoanAmount", "miPremiumAmount", "PAndIPaymentAmount", "rate.netRate", "rateGuaranteeLength", "actualPaymentTerm", "interestTypeDd", "paymentTermDd", "interestAdjustmentDate", "amortizationTerm", "paymentFrequencyDd", "mortgageInsurerId", "mtgProviderId", "miReferenceNumber"])), mapDeal("ApplicationStore", ["estimatedClosingDate"])), mapResponse("ApplicationStore", ["commitment.commitmentExpirationDate"])), {}, {
    rateTypes() {
      return map(InterestTypeE, (value, label) => ({
        label,
        value
      }));
    },
    insurerTypes() {
      return map(MortgageInsurerE, (value, label) => ({
        label,
        value
      }));
    },
    frequencyOptions() {
      return map(PaymentFrequencyE, (value, label) => ({
        label,
        value
      }));
    },
    termTypes() {
      return map(TermTypeE, (value, label) => ({
        label,
        value
      }));
    }
  }),
  watch: {
    "$v.$invalid"(value) {
      this.$emit("validation", !value);
    }
  },
  methods: {
    initSelect2() {
      this.$nextTick(() => {
        this.$refs.select.initSelect2(this.select2Options);
      });
    },
    formatData(data) {
      return data && _mapInstanceProperty(data).call(data, item => {
        return {
          text: item.label,
          value: item.value,
          id: item.value
        };
      });
    },
    handleRateTypeChange({
      value
    }) {
      this.interestTypeDd = value;
    },
    handleFrequencyChange({
      value
    }) {
      this.paymentFrequencyDd = value;
    },
    handleTermTypeChange({
      value
    }) {
      this.paymentTermDd = value;
    },
    handleInsurerChange({
      value
    }) {
      this.mtgProviderId = value;
      this.mortgageInsurerId = value;
    }
  }
});